<template>
  <div class="text-center w-100 ">

    <div class="tasks-title-box w-100 rounded">

      <v-row class="ma-5">
        <v-col cols="7" class="my-auto mx-auto mobile-d-none text-right"><h3>لیست کاربران</h3></v-col>
        <v-col class="text-left" xs="12">
          <v-text-field placeholder="جست و جو کنید"
                        class="search-tasks elevation-0"
                        filled rounded dense
                        v-model="search_field"
                        style="margin-bottom: -25px"
                        append-icon="mdi-magnify"
          ></v-text-field>
        </v-col>
        <v-col class="text-left" xs="12" v-if="$GLOBAL_DATA.user['degree'] > 3">
          <v-btn class="elevation-0" large @click="add_user_dialog.en=true;">
            <v-icon small >mdi-plus</v-icon>
            <div class="mobile-d-none">ثبت کاربر جدید</div>
          </v-btn>
        </v-col>

      </v-row>
    </div>
    <v-alert v-model="users_access_alert"
             v-if="$GLOBAL_DATA.user['degree'] > 3"
             color="warning"
             variant="outlined"
             border="left"
    ><v-row class="pa-5">
      <span>سطح کاربران به ترتیب از دسترسی بالا (سطح ۴) تا دسترسی پایین (سطح ۱) طبقه بندی شده است!</span>
      <v-spacer></v-spacer>
      <v-icon @click="users_access_alert=false">
        mdi-close
      </v-icon>
    </v-row>

    </v-alert>
    <v-row class="text-center" >
      <div v-if="receiving_data" class="w-100 mt-10 text-center">
        <v-progress-circular
            style="margin-right: 45%;position: absolute"
            :size="100"
            :width="7"
            color="#d20003"
            indeterminate
        ></v-progress-circular>
      </div>
      <v-col cols="12" sm="6" md="4" lg="3" xl="3"
             v-for="user in search_field?filter_by_names(users, search_field,'first_name'):users.results"
             v-if="!receiving_data"
             :key="user.username"
             class="mt-5 text-center">
              <v-card class=" br-1em mx-auto mt-10" width="300px" height="450px">
                <div v-if="user['is_superuser']" style="position: absolute;right: 10px;top: 10px;">
                  <v-tooltip top color="red">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" color="yellow" large>mdi-star</v-icon>
                    </template>
                    <div>
                      این کاربر به پنل مدیریت دسترسی دارد و قابل تغییر یا حذف نیست
                    </div>
                  </v-tooltip>
                </div>
                  <v-card-title class=" mt-8 text-center">
                    <v-avatar size="100" class="mx-auto" style="margin-top:-3em;border:10px #eef2f4 solid;background-color: #eef2f4;">
                      <img
                          v-if="user.profile_picture_url"
                          alt="user"
                          :src="user.profile_picture_url"
                      >
                      <v-icon v-else style="font-size: 4.5em">
                        mdi-account-circle
                      </v-icon>
                    </v-avatar>
                  </v-card-title>
                    <div class=" mx-auto  " :style="`font-size: 25px;${user['is_superuser']?'color: #D20003;font-weight:bold;':''}`">
                      {{ user["get_full_name"]}}
                    </div>


                <v-card-text>
                  <div class="mx-8">
                    <v-row v-if="user['last_login']">
                      <p class="text-center ml-auto">آخرین ورود : </p>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <p v-bind="attrs" v-on="on"
                             class="text-black"
                          >{{new Date(user.last_login.split('T')[0]).toLocaleDateString('fa-IR')}}</p>
                        </template>
                        <span>{{ convert_en_to_fa_number(user.last_login.split('T')[1].slice(0,5)) }}</span>
                      </v-tooltip>
                    </v-row>
                    <v-row v-else>
                      <p class="text-center ml-auto">آخرین ورود : </p>
                      <p class="text-center mr-auto text-black">بدون ورود</p>
                    </v-row>
                    <v-row>
                      <p class="text-center ml-auto">نام کاربری : </p>
                      <p class="text-center mr-auto text-black">{{ user.username }}</p>
                    </v-row>
                    <v-row>
                      <p class="text-center ml-auto">تلفن : </p>
                      <p class="text-center mr-auto text-black">{{user["phone_number"]?user["phone_number"]:'ثبت نشده'}}</p>
                    </v-row>
                    <v-row>
                      <p class="text-center ml-auto">سطح : </p>
                      <p class="text-center mr-auto text-black">{{user['degree']}}</p>
                    </v-row>
                    <v-row v-if="!(user['is_superuser'] || (user['username'] == $GLOBAL_DATA.user['username']))">
                      <v-col><p class="text-center ml-auto">فعال : </p></v-col>
                      <v-col><v-switch :loading="active_user_loading===user['username']" inset v-model="user['is_active']" @change="active_user_loading=user['username'];change_active_user(user)"></v-switch></v-col>
                    </v-row>
                  </div>
                </v-card-text>
                  <div class="text-center" style="position: absolute;bottom: 0;width: 100%">
                    <v-select
                        v-if="!user['is_superuser'] && $GLOBAL_DATA.user['degree'] > 3"
                        :items="[1, 2, 3, 4]"
                        v-model="user['degree']"
                        @change="change_degree_user(user.username, user['degree'])"
                        label="انتخاب سطح"
                        filled
                        dense
                        rounded
                        class="accounts-select-stage-input mx-auto"
                    ></v-select>

                    <!--                  <v-spacer v-else class="my-7"><div class="py-4"></div></v-spacer>-->
                      <v-btn color="error"
                             rounded block large
                             style="border-radius: 0 0 1em 1em;"
                             class="elevation-2 text-bold"
                             v-if="$GLOBAL_DATA.user['degree'] > 3"
                             :disabled="user['is_superuser']"
                             @click="dialog=true;will_remove_username=user.username">
                        حذف کاربر
                      </v-btn>
                  </div>
              </v-card>
      </v-col>


    </v-row>
    <v-pagination
        v-model="page"
        color="#D20003"
        class="mt-5"
        rounded
        @input="get_users()"
        v-if="users.count >= 12"
        :length="users.count%12!==0?parseInt(users.count/12)+1:parseInt(users.count/12)"
        :total-visible="5"
    ></v-pagination>
    <v-dialog
        v-model="dialog"
        persistent
        max-width="600"

        class="br-1em"
    >
      <v-card class="br-1em">
        <v-card-title>
          <h4 class="mx-auto">
            آیا میخواهید کاربر '<i>{{ will_remove_username }}</i>' را حذف کنید ؟
          </h4>
        </v-card-title>
        <v-card-actions class="text-center pb-5">
          <v-spacer></v-spacer>

          <v-btn
              color="green"
              @click="dialog = false"
              large text
              class="elevation-0"
          >
            بازگشت
          </v-btn>
          <v-spacer></v-spacer>

          <v-btn
              color="error"
              class="elevation-0"
              :loading="remove_user_loading"
              @click="remove_users(will_remove_username)"
          >
            حذف
            {{ will_remove_username }}
          </v-btn>
          <v-spacer></v-spacer>

        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
        scrollable
        v-model="add_user_dialog.en"
        max-width="500"
    >
      <v-card >
        <v-card-title>
          افزودن کاربر
          <v-spacer></v-spacer>
          <div
              @click="add_user_dialog.en=false;"
          >
            <svg width="44" height="44" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="44" height="44" rx="22" class="back-btn"/>
              <path d="M28.6665 22.2285C28.6665 22.5449 28.4314 22.8064 28.1263 22.8478L28.0415 22.8535L15.5415 22.8535C15.1963 22.8535 14.9165 22.5737 14.9165 22.2285C14.9165 21.9121 15.1516 21.6506 15.4567 21.6092L15.5415 21.6035L28.0415 21.6035C28.3867 21.6035 28.6665 21.8833 28.6665 22.2285Z" fill="black"/>
              <path d="M21.024 26.8059C21.2686 27.0495 21.2695 27.4452 21.0259 27.6898C20.8045 27.9122 20.4573 27.9331 20.2122 27.7521L20.142 27.6917L15.1004 22.6717C14.8773 22.4497 14.857 22.1012 15.0395 21.8562L15.1003 21.786L20.142 16.7652C20.3866 16.5216 20.7823 16.5224 21.0259 16.767C21.2473 16.9893 21.2667 17.3366 21.0847 17.5809L21.024 17.6509L16.4273 22.2291L21.024 26.8059Z" fill="black"/>
            </svg>
          </div>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-text-field v-model="add_user_dialog.form.first_name"
                          :error-messages="add_user_dialog.errors['first_name']"
                          rounded outlined label="نام"></v-text-field>
            <v-text-field v-model="add_user_dialog.form.last_name"
                          :error-messages="add_user_dialog.errors['last_name']"
                          rounded outlined label="نام خانوادگی"></v-text-field>
            <v-text-field v-model="add_user_dialog.form.phone_number"
                          :error-messages="add_user_dialog.errors['phone_number']"
                          rounded outlined label="شماره همراه"></v-text-field>
            <v-text-field v-model="add_user_dialog.form.username"
                          :error-messages="add_user_dialog.errors['username']"
                          rounded outlined label="نام کاربری"></v-text-field>
            <v-text-field
                v-model="add_user_dialog.form.password"
                :error-messages="add_user_dialog.errors['password']"
                rounded outlined label="کلمه عبور"
            ></v-text-field>

            <v-select
                :items="[1, 2, 3, 4]"
                v-model="add_user_dialog.form['degree']"
                label="سطح کاربر"
                :error-messages="add_user_dialog.errors['degree']"
                filled dense rounded
                class="mx-auto"
            ></v-select>
          </v-container>
        </v-card-text>
        <v-card-actions style="padding: 0 !important;" >
          <v-btn block large
                 class="elevation-0 text-bold rounded-0"
                 color="success"
                 @click="send_user"
                 :loading="add_user_dialog.btn_loading"
                 :disabled="!(add_user_dialog.form.first_name && add_user_dialog.form.last_name && add_user_dialog.form.phone_number && add_user_dialog.form.username && add_user_dialog.form.degree)">
            افزودن کاربر
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "HomeAccounts",
  data:()=>({
    key: localStorage.getItem('key'),
    user:null,
    users_access_alert:true,
    receiving_data: false,
    will_remove_username:'',
    users:[],
    remove_user_loading:false,
    search_field: null,
    dialog:false,
    page:1,
    active_user_loading:false,
    add_user_dialog:{
      en:false,
      form:{},
      errors: {},
      btn_loading:false,
    },
  }),
  created() {
    this.get_users();
  },
  methods:{
    send_user(){
      let user = new FormData();
        user.append('first_name', this.add_user_dialog.form.first_name);
        user.append('last_name', this.add_user_dialog.form.last_name);
        user.append('phone_number', this.add_user_dialog.form.phone_number);
        user.append('username', this.add_user_dialog.form.username);
        user.append('degree', this.add_user_dialog.form.degree);
        user.append('password', this.add_user_dialog.form.password);


        axios.post(this.BACKEND_LINK + '/api/account-admin/user-add/', user, {
          headers: {'Authorization': `Token ${this.key}`}
        }).then(() => {
          this.add_user_dialog.en = false;
          this.$snotify.success(`کاربر ${this.add_user_dialog.form.last_name} با موفقیت ایجاد شد.`, 'ایجاد کاربر')
          this.get_users()
        }).catch((error) => {
          this.add_user_dialog.errors = error.response.data
          this.$snotify.error(`مشکلی در ثبت کاربر وجود دارد!`, 'خطا')
        })
    },
    change_degree_user(username, degree){
      const data = new FormData();
      data.append('username',username);
      data.append('degree',degree);

      axios.put(this.BACKEND_LINK + '/api/account-admin/users-update/', data, {
        headers: {'Authorization': `Token ${this.key}`}
      }).then((response)=>{
        this.$snotify.success(response.data, 'تغیر سطح')
      }).catch((response)=>{
        this.$snotify.error(response.data, 'تغیر سطح');
     });
    },
    get_users(){
      this.receiving_data = true;
      axios.get(this.BACKEND_LINK + '/api/account-admin/users-list?page_size=12&page=' + this.page, {
        headers: {'Authorization': `Token ${this.key}`}
      }).then((response)=>{
        this.users = response.data;
      }).finally(()=>{
        this.receiving_data = false;
      })
    },
    change_active_user(user){
      axios.put(this.BACKEND_LINK + '/api/account-admin/users-active',{
        username: user['username'],
        is_active: user['is_active']
      }, {
        headers: {'Authorization': `Token ${this.key}`}
      }).then((response) => {
        this.get_users();
        this.$snotify.success(response.data, 'وضعیت کاربر')
      }).finally(()=>{
        this.active_user_loading = false;
      })
    },
    remove_users(username) {
      this.remove_user_loading = true;
      axios.delete(this.BACKEND_LINK + '/api/account-admin/users-destroy?username=' + username, {
        headers: {'Authorization': `Token ${this.key}`}
      }).then((response) => {
        this.get_users();
        this.remove_user_loading = false;
        this.dialog = false;
        this.$snotify.success(response.data, 'حذف کاربر')
      });
    }
  }
}
</script>

<style scoped>

</style>
